import { useAtom, useSetAtom } from "jotai";
import React from "react";
import {
  Q3WhatPublicAdministrationSubSectorsAtom,
  Q4WhatSizeAndRevenueAtom,
  Q5WhichOnesAreCorrectAtom,
  Q6WhatActivitiesAtom,
  displayQ5WhichOnesAreCorrectAtom,
  displayQ6WhatActivitiesAtom,
} from "../../../../../atoms/NIS2Atom";
import {
  answersManagementForQ2SectorsOfActivity,
  resetQ5WhichOnesAreCorrect,
  resetQ6WhatActivties,
  resetSizeAndRevenue,
} from "../../../../../utils/functions/Version3/functionsForNIS2Management";

const PublicAdministrationSubSectors = ({ setDisplayQ4WhatSizeAndRevenue }) => {
  const [
    Q3WhatPublicAdministrationSubSectors,
    setQ3WhatPublicAdministrationSubSectors,
  ] = useAtom(Q3WhatPublicAdministrationSubSectorsAtom);

  const setQ4WhatSizeAndRevenue = useSetAtom(Q4WhatSizeAndRevenueAtom);

  const setQ5WhichOnesAreCorrect = useSetAtom(Q5WhichOnesAreCorrectAtom);
  const setDisplayQ5WhichOnesAreCorrect = useSetAtom(
    displayQ5WhichOnesAreCorrectAtom
  );

  const setDisplayQ6WhatActivities = useSetAtom(displayQ6WhatActivitiesAtom);

  const setQ6WhatActivities = useSetAtom(Q6WhatActivitiesAtom);

  return (
    <>
      <div className="nis2-sub-sectors-container">
        <div>
          <label className="nis2-form-sub-answers">
            <input
              className="nis2-form-answers-input"
              type="checkbox"
              name="entités de l'administration publique des pouvoirs publics centraux"
              checked={Q3WhatPublicAdministrationSubSectors.includes(
                "entités de l'administration publique des pouvoirs publics centraux"
              )}
              onChange={(e) =>
                answersManagementForQ2SectorsOfActivity(
                  e,
                  Q3WhatPublicAdministrationSubSectors,
                  setQ3WhatPublicAdministrationSubSectors
                )
              }
              onClick={() => {
                resetSizeAndRevenue(
                  setQ4WhatSizeAndRevenue,
                  setDisplayQ4WhatSizeAndRevenue
                );
                resetQ5WhichOnesAreCorrect(
                  setQ5WhichOnesAreCorrect,
                  setDisplayQ5WhichOnesAreCorrect
                );
                resetQ6WhatActivties(
                  setQ6WhatActivities,
                  setDisplayQ6WhatActivities
                );
              }}
            />
            Entités de l'administration publique des pouvoirs publics centraux
          </label>
        </div>

        <div>
          <label className="nis2-form-sub-answers">
            <input
              className="nis2-form-answers-input"
              type="checkbox"
              name="entités de l'administration publique au niveau régional"
              checked={Q3WhatPublicAdministrationSubSectors.includes(
                "entités de l'administration publique au niveau régional"
              )}
              onChange={(e) =>
                answersManagementForQ2SectorsOfActivity(
                  e,
                  Q3WhatPublicAdministrationSubSectors,
                  setQ3WhatPublicAdministrationSubSectors
                )
              }
              onClick={() => {
                resetSizeAndRevenue(
                  setQ4WhatSizeAndRevenue,
                  setDisplayQ4WhatSizeAndRevenue
                );
                resetQ5WhichOnesAreCorrect(
                  setQ5WhichOnesAreCorrect,
                  setDisplayQ5WhichOnesAreCorrect
                );
                resetQ6WhatActivties(
                  setQ6WhatActivities,
                  setDisplayQ6WhatActivities
                );
              }}
            />
            Entités de l'administration publique au niveau régional
          </label>
        </div>

        <div>
          <label className="nis2-form-sub-answers">
            <input
              className="nis2-form-answers-input"
              type="checkbox"
              name="aucun de la liste"
              checked={Q3WhatPublicAdministrationSubSectors.includes(
                "aucun de la liste"
              )}
              onChange={(e) =>
                answersManagementForQ2SectorsOfActivity(
                  e,
                  Q3WhatPublicAdministrationSubSectors,
                  setQ3WhatPublicAdministrationSubSectors
                )
              }
              onClick={() => {
                resetSizeAndRevenue(
                  setQ4WhatSizeAndRevenue,
                  setDisplayQ4WhatSizeAndRevenue
                );
                resetQ5WhichOnesAreCorrect(
                  setQ5WhichOnesAreCorrect,
                  setDisplayQ5WhichOnesAreCorrect
                );
                resetQ6WhatActivties(
                  setQ6WhatActivities,
                  setDisplayQ6WhatActivities
                );
              }}
            />
            Aucun de la liste
          </label>
        </div>
      </div>
    </>
  );
};

export default PublicAdministrationSubSectors;
